import { create } from "zustand";

type ResolvedMicrophone = {
  deviceId: string | null;
  deviceName: string | null;
  isFallback: boolean;
};

type MicrophoneRuntimeState = ResolvedMicrophone & {
  setResolvedMicrophone: (microphone: ResolvedMicrophone) => void;
};

/**
 * 実際の録音に使用するマイクを保持する非永続ストア。
 * ユーザーが選択したマイク設定とは分離し、再列挙やフォールバックで
 * selectedMicrophoneId / selectedMicrophoneName を上書きしない。
 */
export const useMicrophoneRuntime = create<MicrophoneRuntimeState>((set) => ({
  deviceId: null,
  deviceName: null,
  isFallback: false,
  setResolvedMicrophone: (microphone) => set(microphone),
}));
